// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ScheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import TwoButtonModal, { TwoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { OverflowMenuPresentationProps } from "@insite/mobius/OverflowMenu";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { getStoreListState } from "@store/Framework/Store/Data/StoreLists/StoreListsSelector";
import deleteStoreList from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/DeleteStoreList";
import updateCustomersPagination from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/UpdateCustomersPagination";
import updateShipTosPagination from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/UpdateShipTosPagination";
import StoreListsDetailsShipTosList from "@store/Library/Components/StoreListsDetails/StoreListsDetailsShipTosList";
import StoreListsEditListForm from "@store/Library/Widgets/StoreLists/StoreListsEditListForm";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import debounce from "lodash/debounce";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface State {
    updateListModalIsOpen: boolean;
    deleteListModalIsOpen: boolean;
    addStoreModalIsOpen: boolean;
    searchValue: string;
}

const mapStateToProps = (state: ApplicationState) => ({
    currentBillTo: getCurrentBillToState(state).value,
    storeList: getStoreListState(state, state.store.pages.storeListsDetails.storeListId).value,
    storeListsPageLink: getPageLinkByPageType(state, "StoreListPage"),
    defaultPageSize: getSettingsCollection(state).websiteSettings.defaultPageSize,
    shipTosParameter: state.store.pages.storeListsDetails.shipTosParameter,
    customersParameter: state.store.pages.storeListsDetails.customersParameter,
});

const mapDispatchToProps = {
    deleteStoreList,
    updateShipTosPagination,
    updateCustomersPagination,
};

type Props = WidgetProps & HasHistory & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface MyListsDetailsActionStyles {
    wrapper?: InjectableCss;
    buttonWrapper?: InjectableCss;
    overflowMenu?: OverflowMenuPresentationProps;
    editButton?: ButtonPresentationProps;
    editListModal?: ModalPresentationProps;
    deleteListModal?: TwoButtonModalStyles;
    deleteListItemsModal?: TwoButtonModalStyles;
    printListModal?: TwoButtonModalStyles;
    scheduleReminderModal?: ScheduleReminderModalStyles;
    deleteButton?: ButtonPresentationProps;
    addStoreButton?: ButtonPresentationProps;
    addStoreListModal?: ModalPresentationProps;
    searchWrapper?: InjectableCss;
    searchInput?: TextFieldPresentationProps;
}

const buttonBreakpointStyles = css`
    ${breakpoint("xs", "only")} {
        width: 40%;
        margin: ${pxToRem(10)};
    }
`;

const buttonStyles = css`
    padding: 0 ${pxToRem(15)};
    margin-top: ${pxToRem(15)};
    margin-right: ${pxToRem(10)};
`;

export const actionStyles: MyListsDetailsActionStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: space-between;

            ${breakpoint("xs", "only")} {
                justify-content: center;
            }
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            align-items: flex-start;
            flex-wrap: wrap;
            margin: ${pxToRem(16)} 0;
            width: 100%;

            ${breakpoint("xs", "only")} {
                justify-content: space-between;
            }
        `,
    },
    editButton: {
        css: css`
            ${buttonStyles} ${buttonBreakpointStyles}
        `,
        variant: "secondary",
    },
    editListModal: {
        sizeVariant: "small",
    },
    deleteButton: {
        css: css`
            ${buttonStyles} ${buttonBreakpointStyles}
        `,
        variant: "secondary",
    },
    addStoreButton: {
        css: css`
            ${buttonStyles} ${buttonBreakpointStyles}
        `,
        variant: "primary",
    },
    addStoreListModal: {
        size: 1200,
        cssOverrides: {
            modalBody: css`
                height: 100% !important;
            `,
            modalContent: css`
                overflow-y: auto;
            `,
        },
    },
    searchWrapper: {
        css: css`
            max-width: ${pxToRem(300)};
            ${spacingStyles(null, "1.25em")}
        `,
    },
    searchInput: {
        iconProps: { src: "Search" },
    },
};

const styles = actionStyles;

class StoreListsDetailsActions extends React.Component<Props, State> {
    static contextType = ToasterContext;
    context!: React.ContextType<typeof ToasterContext>;

    constructor(props: Props) {
        super(props);
        this.state = {
            updateListModalIsOpen: false,
            deleteListModalIsOpen: false,
            addStoreModalIsOpen: false,
            searchValue: "",
        };
    }

    componentDidMount() {
        if (this.props.defaultPageSize) {
            if (this.props.storeList?.id) {
                this.props.updateCustomersPagination({
                    pageSize: this.props.defaultPageSize,
                    storeListId: this.props.storeList?.id,
                });
            }

            this.props.updateShipTosPagination({
                pageSize: this.props.defaultPageSize,
                billToId: this.props.currentBillTo?.id,
                additionalExpands: ["loadAllShipTos"],
                storeListId: this.props.storeList?.id,
            });
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (
            this.props.defaultPageSize !== prevProps.defaultPageSize ||
            this.props.currentBillTo?.id !== prevProps.currentBillTo?.id ||
            this.props.storeList?.id !== prevProps.storeList?.id
        ) {
            this.props.updateShipTosPagination({
                pageSize: this.props.defaultPageSize,
                billToId: this.props.currentBillTo?.id,
                storeListId: this.props.storeList?.id,
            });
            this.props.updateCustomersPagination({
                pageSize: this.props.defaultPageSize,
                storeListId: this.props.storeList?.id,
            });
        }
    }

    displayToast(message: React.ReactNode) {
        this.context.addToast({ body: message, messageType: "success" });
    }

    editClickHandler = () => {
        this.setState({ updateListModalIsOpen: true });
    };

    editCloseHandler = () => {
        this.setState({ updateListModalIsOpen: false });
    };

    deleteClickHandler = () => {
        this.setState({ deleteListModalIsOpen: true });
    };

    deleteCancelHandler = () => {
        this.setState({ deleteListModalIsOpen: false });
    };

    deleteSubmitHandler = () => {
        if (!this.props.storeList) {
            return;
        }

        this.setState({ deleteListModalIsOpen: false });
        this.props.storeListsPageLink && this.props.history.push(this.props.storeListsPageLink.url);
        this.props.deleteStoreList({
            storeListId: this.props.storeList.id,
            onSuccess: this.onDeleteSuccess,
            onComplete() {
                this.onSuccess?.();
            },
        });
    };

    onDeleteSuccess = () => {
        this.displayToast(translate("List Deleted"));
    };

    addStoreClickHandler = () => {
        this.setState({ addStoreModalIsOpen: true });
    };

    addStoreCloseHandler = () => {
        this.clearSearch();
        this.setState({ addStoreModalIsOpen: false });
    };

    addStoreModalCloseHandler = () => {
        this.clearSearch();
        this.setState({ addStoreModalIsOpen: false });
    };

    onSearch = (value: string) => {
        this.props.updateShipTosPagination({ ...this.props.shipTosParameter, page: 1, filter: value });
    };

    debouncedSearch = debounce((query: string) => this.onSearch(query), 300);

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.currentTarget.value;
        this.setState({ searchValue: newValue });
        this.debouncedSearch(newValue);
    };

    clearSearch = () => {
        this.setState({ searchValue: "" });
        this.debouncedSearch("");
    };

    render() {
        const { storeList } = this.props;
        if (!storeList) {
            return null;
        }
        return (
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.buttonWrapper} data-test-selector="menuWrapper">
                    <Button
                        {...styles.addStoreButton}
                        onClick={this.addStoreClickHandler}
                        data-test-selector="addStore"
                    >
                        {translate("Add Stores")}
                    </Button>
                    <Button {...styles.deleteButton} onClick={this.deleteClickHandler} data-test-selector="deleteList">
                        {translate("Delete Store List")}
                    </Button>
                    <Button {...styles.editButton} onClick={this.editClickHandler} data-test-selector="editList">
                        {translate("Edit")}
                    </Button>
                </StyledWrapper>
                <Modal
                    headline={translate("Edit List Detail")}
                    {...styles.editListModal}
                    isOpen={this.state.updateListModalIsOpen}
                    handleClose={this.editCloseHandler}
                >
                    <StoreListsEditListForm
                        storeList={storeList}
                        onCancel={this.editCloseHandler}
                        onSubmit={this.editCloseHandler}
                    ></StoreListsEditListForm>
                </Modal>
                <TwoButtonModal
                    headlineText={translate("Delete List")}
                    {...styles.deleteListModal}
                    modalIsOpen={this.state.deleteListModalIsOpen}
                    messageText={`${translate("Are you sure you want to delete")} ${storeList.name}?`}
                    cancelButtonText={translate("Cancel")}
                    submitButtonText={translate("Delete")}
                    onCancel={this.deleteCancelHandler}
                    onSubmit={this.deleteSubmitHandler}
                    submitTestSelector="submitDeleteList"
                ></TwoButtonModal>
                <Modal
                    headline={translate("Add Stores")}
                    {...styles.addStoreListModal}
                    isOpen={this.state.addStoreModalIsOpen}
                    handleClose={this.addStoreCloseHandler}
                >
                    <StyledWrapper {...styles.searchWrapper}>
                        <TextField
                            label={translate("Search for a store")}
                            onChange={this.onChange}
                            value={this.state.searchValue}
                            {...styles.searchInput}
                        />
                    </StyledWrapper>
                    <StoreListsDetailsShipTosList
                        shipTosParameter={this.props.shipTosParameter}
                        customerList={storeList.customerList}
                        closeModalHandler={this.addStoreModalCloseHandler}
                    ></StoreListsDetailsShipTosList>
                </Modal>
            </StyledWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(StoreListsDetailsActions)),
    definition: {
        group: constants.widgetGroup.storeListDetails,
        displayName: "Store List Details Actions",
    },
};

export default widgetModule;
